(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-gt-tailles-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bkGtTabsInit) return;
    window.__bkGtTabsInit = true;

    function activate(tab) {
      var sizer = tab.closest('.bk-gt-sizer');
      if (!sizer) return;
      var tabs = sizer.querySelectorAll('.bk-gt-tab');
      var panels = sizer.querySelectorAll('.bk-gt-panel');
      for (var j = 0; j < tabs.length; j++) {
        var active = tabs[j] === tab;
        tabs[j].classList.toggle('is-active', active);
        tabs[j].setAttribute('aria-selected', active ? 'true' : 'false');
        tabs[j].setAttribute('tabindex', active ? '0' : '-1');
        if (panels[j]) panels[j].classList.toggle('is-active', active);
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var tab = e.target.closest('.bk-gt-tab');
      if (tab) activate(tab);
    });

    /* Éditeur de thème : sélectionner un bloc « Taille » active son onglet
       pour que le panneau soit visible pendant l'édition. */
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target;
      if (!panel || !panel.classList || !panel.classList.contains('bk-gt-panel')) return;
      var tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (tab) activate(tab);
    });

    document.addEventListener('keydown', function (e) {
      if (!e.target || !e.target.closest) return;
      var tab = e.target.closest('.bk-gt-tab');
      if (!tab) return;
      var key = e.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
      var sizer = tab.closest('.bk-gt-sizer');
      if (!sizer) return;
      var tabs = Array.prototype.slice.call(sizer.querySelectorAll('.bk-gt-tab'));
      var i = tabs.indexOf(tab);
      var next = key === 'ArrowLeft' ? (i - 1 + tabs.length) % tabs.length
               : key === 'ArrowRight' ? (i + 1) % tabs.length
               : key === 'Home' ? 0
               : tabs.length - 1;
      e.preventDefault();
      tabs[next].focus();
      activate(tabs[next]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-gt-tailles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bkGtTabsInit) return;
    window.__bkGtTabsInit = true;

    function activate(tab) {
      var sizer = tab.closest('.bk-gt-sizer');
      if (!sizer) return;
      var tabs = sizer.querySelectorAll('.bk-gt-tab');
      var panels = sizer.querySelectorAll('.bk-gt-panel');
      for (var j = 0; j < tabs.length; j++) {
        var active = tabs[j] === tab;
        tabs[j].classList.toggle('is-active', active);
        tabs[j].setAttribute('aria-selected', active ? 'true' : 'false');
        tabs[j].setAttribute('tabindex', active ? '0' : '-1');
        if (panels[j]) panels[j].classList.toggle('is-active', active);
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var tab = e.target.closest('.bk-gt-tab');
      if (tab) activate(tab);
    });

    /* Éditeur de thème : sélectionner un bloc « Taille » active son onglet
       pour que le panneau soit visible pendant l'édition. */
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target;
      if (!panel || !panel.classList || !panel.classList.contains('bk-gt-panel')) return;
      var tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (tab) activate(tab);
    });

    document.addEventListener('keydown', function (e) {
      if (!e.target || !e.target.closest) return;
      var tab = e.target.closest('.bk-gt-tab');
      if (!tab) return;
      var key = e.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
      var sizer = tab.closest('.bk-gt-sizer');
      if (!sizer) return;
      var tabs = Array.prototype.slice.call(sizer.querySelectorAll('.bk-gt-tab'));
      var i = tabs.indexOf(tab);
      var next = key === 'ArrowLeft' ? (i - 1 + tabs.length) % tabs.length
               : key === 'ArrowRight' ? (i + 1) % tabs.length
               : key === 'Home' ? 0
               : tabs.length - 1;
      e.preventDefault();
      tabs[next].focus();
      activate(tabs[next]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-guide-fit-avant"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bk-guide-fit-avant')) {
    customElements.define('bk-guide-fit-avant', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.panels = Array.from(this.querySelectorAll('[data-category-panel]'));
        this.measurements = this.measurements || new Map();
        this.confirmedMeasurements = this.confirmedMeasurements || new Map();
        this.path = this.path || 'measure';
        this.setupBreeds();
        this.unit = this.unit || (this.dataset.defaultUnit === 'in' ? 'in' : 'cm');
        this.labels = {
          cm: this.querySelector('[data-unit="cm"]')?.textContent || '',
          in: this.querySelector('[data-unit="in"]')?.textContent || ''
        };
        this.panels.forEach(panel => {
          const table = panel.querySelector('[data-size-table]');
          if (table) table.open = this.dataset.tablesOpen === 'true';
          this.renderRangeUnits(panel);
        });
        this.addEventListener('click', event => {
          const pathButton = event.target.closest('[data-path-button]');
          if (pathButton && this.contains(pathButton)) this.selectPath(pathButton.dataset.pathButton);
          const nowMeasure = event.target.closest('[data-now-measure]');
          if (nowMeasure && this.contains(nowMeasure)) this.selectPath('measure', true);
          const breedOption = event.target.closest('[data-breed-option]');
          if (breedOption && this.contains(breedOption)) this.chooseBreed(breedOption.dataset.breedOption);
          const breedInput = event.target.closest('[data-breed-input]');
          if (breedInput && this.contains(breedInput)) this.renderBreedOptions(breedInput.closest('[data-category-panel]'));
          const categoryButton = event.target.closest('[data-category-button]');
          if (categoryButton && this.contains(categoryButton)) this.selectCategory(categoryButton.dataset.categoryButton);
          const unitButton = event.target.closest('[data-unit]');
          if (unitButton && this.contains(unitButton)) this.setUnit(unitButton.dataset.unit);
          const tableLink = event.target.closest('[data-table-link]');
          if (tableLink && this.contains(tableLink)) {
            event.preventDefault();
            this.openTable(tableLink.closest('[data-category-panel]'), true);
          }
        }, { signal });
        this.addEventListener('input', event => {
          const breedInput = event.target.closest('[data-breed-input]');
          if (breedInput && this.contains(breedInput)) {
            this.breedHandle = null;
            this.breedSubmitted = false;
            this.breedQuery = breedInput.value;
            this.panels.forEach(panel => {
              this.resetBreedResult(panel);
              const other = panel.querySelector('[data-breed-input]');
              if (other && other !== breedInput) other.value = this.breedQuery;
            });
            this.syncPath();
            this.renderBreedOptions(breedInput.closest('[data-category-panel]'));
            return;
          }
          const input = event.target.closest('[data-measure-form] input');
          if (!input || !this.contains(input)) return;
          const panel = input.closest('[data-category-panel]');
          const number = input.valueAsNumber;
          this.measurements.set(panel.dataset.categoryPanel, Number.isFinite(number) ? number * (this.unit === 'in' ? 2.54 : 1) : null);
          this.confirmedMeasurements.delete(panel.dataset.categoryPanel);
          this.resetResult(panel);
        }, { signal });
        this.addEventListener('submit', event => {
          const breedForm = event.target.closest('[data-breed-form]');
          if (breedForm && this.contains(breedForm)) {
            event.preventDefault();
            this.breedSubmitted = true;
            this.closeBreedLists();
            this.syncPath();
            this.openTable(breedForm.closest('[data-category-panel]'), false);
            return;
          }
          const form = event.target.closest('[data-measure-form]');
          if (!form || !this.contains(form)) return;
          event.preventDefault();
          const input = form.querySelector('input');
          if (!input.reportValidity()) return;
          const panel = form.closest('[data-category-panel]');
          const number = input.valueAsNumber;
          if (!Number.isFinite(number) || number <= 0) return;
          if (!Number.isFinite(this.measurements.get(panel.dataset.categoryPanel))) {
            this.measurements.set(panel.dataset.categoryPanel, number * (this.unit === 'in' ? 2.54 : 1));
          }
          this.confirmedMeasurements.set(panel.dataset.categoryPanel, this.measurements.get(panel.dataset.categoryPanel));
          this.resetBreedResult(panel);
          panel.querySelector('.bk-guide-fit-avant__result').hidden = false;
          this.renderMeasurement(panel);
          this.renderMatches(panel);
          this.openTable(panel, false);
        }, { signal });
        this.addEventListener('focusin', event => {
          const input = event.target.closest('[data-breed-input]');
          if (input && this.contains(input)) this.renderBreedOptions(input.closest('[data-category-panel]'));
        }, { signal });
        this.addEventListener('focusout', event => {
          const picker = event.target.closest('[data-breed-picker]');
          if (picker && !picker.contains(event.relatedTarget)) this.closeBreedLists();
        }, { signal });
        this.addEventListener('pointerdown', event => {
          const option = event.target.closest('[data-breed-option]');
          if (option && this.contains(option)) event.preventDefault();
        }, { signal });
        this.addEventListener('keydown', event => {
          const input = event.target.closest('[data-breed-input]');
          if (input && this.contains(input)) this.onBreedKeydown(event, input.closest('[data-category-panel]'));
        }, { signal });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closeBreedLists();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const selected = event.target.closest('[data-block-id]');
          const panel = selected?.closest('[data-category-panel]');
          if (!panel) return;
          this.selectCategory(panel.dataset.categoryPanel);
          if (selected !== panel) this.openTable(panel, false);
        }, { signal });
        this.setAttribute('data-enhanced', '');
        const active = this.panels.find(panel => panel.dataset.categoryPanel === this.activeCategory) || this.panels[0];
        this.selectCategory(active?.dataset.categoryPanel);
        this.setUnit(this.unit);
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.closeBreedLists();
        this.removeAttribute('data-enhanced');
        this.panels?.forEach(panel => {
          panel.hidden = false;
          const table = panel.querySelector('[data-size-table]');
          if (table) table.open = true;
        });
        this.querySelectorAll('[data-unit-column]').forEach(column => { column.hidden = false; });
      }
      selectCategory(id) {
        if (!id) return;
        this.activeCategory = id;
        this.panels.forEach(panel => { panel.hidden = panel.dataset.categoryPanel !== id; });
        this.querySelectorAll('[data-category-button]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.categoryButton === id));
        });
        this.closeBreedLists();
        this.syncPath();
      }
      setupBreeds() {
        let records = [];
        this.breedLabels = {};
        try {
          records = JSON.parse(this.querySelector('[data-breed-data]')?.textContent || '[]');
          this.breedLabels = JSON.parse(this.querySelector('[data-breed-labels]')?.textContent || '{}');
        } catch {
          records = [];
        }
        if (!Array.isArray(records)) records = [];
        if (!this.breedLabels || typeof this.breedLabels !== 'object' || Array.isArray(this.breedLabels)) this.breedLabels = {};
        this.breeds = records.filter(breed => breed && typeof breed.handle === 'string' && breed.handle && breed.handle !== '__unknown__' && typeof breed.name === 'string' && breed.name.trim() && records.filter(record => record?.handle === breed.handle).length === 1);
        this.breeds.sort((a, b) => a.name.localeCompare(b.name, document.documentElement.lang || 'fr'));
        if (this.breedHandle && this.breedHandle !== '__unknown__' && !this.breeds.some(breed => breed.handle === this.breedHandle)) {
          this.breedHandle = null;
          this.breedSubmitted = false;
        }
        const selected = this.breeds.find(breed => breed.handle === this.breedHandle);
        if (selected || this.breedHandle === '__unknown__') this.breedQuery = selected?.name || this.breedLabels.unknown || '';
        this.querySelectorAll('[data-breed-input]').forEach(input => { input.value = this.breedQuery || ''; });
      }
      normalizeSearch(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      }
      normalizeSize(value) {
        const normalized = this.normalizeSearch(value).replace(/[-‐‑‒–—−]/g, ' ').replace(/\s+/g, ' ').trim();
        const aliases = {
          'tt petit': 'xxs', 'xx small': 'xxs', 'xxs': 'xxs',
          't petit': 'xs', 'x small': 'xs', 'xs': 'xs',
          'petit': 's', 'small': 's', 's': 's',
          'moyen': 'm', 'medium': 'm', 'm': 'm',
          'large': 'l', 'l': 'l'
        };
        return Object.hasOwn(aliases, normalized) ? aliases[normalized] : null;
      }
      selectPath(path, moveFocus = false) {
        if (path !== 'measure' && path !== 'breed') return;
        this.path = path;
        this.closeBreedLists();
        this.syncPath();
        if (moveFocus) {
          this.panels.find(panel => panel.dataset.categoryPanel === this.activeCategory)?.querySelector('[data-measure-form] input')?.focus({ preventScroll: true });
        }
      }
      syncPath() {
        this.panels.forEach(panel => {
          const breedPath = panel.querySelector('[data-breed-path]');
          const measurePath = panel.querySelector('[data-measure-path]');
          const useBreed = Boolean(breedPath) && this.path === 'breed' && panel.dataset.mode === 'measurement';
          this.updateBreedPhoto(panel, useBreed);
          if (breedPath) breedPath.hidden = !useBreed;
          if (measurePath) measurePath.hidden = useBreed;
          panel.querySelectorAll('[data-path-button]').forEach(button => {
            button.setAttribute('aria-pressed', String(button.dataset.pathButton === (useBreed ? 'breed' : 'measure')));
          });
          this.resetResult(panel);
          this.resetBreedResult(panel);
          if (useBreed && this.breedSubmitted) this.renderBreedResult(panel);
          if (!useBreed && panel.dataset.mode === 'measurement') {
            const cm = this.measurements.get(panel.dataset.categoryPanel);
            if (Number.isFinite(cm) && cm > 0 && this.confirmedMeasurements?.get(panel.dataset.categoryPanel) === cm) {
              const result = panel.querySelector('.bk-guide-fit-avant__result');
              if (result) result.hidden = false;
              this.renderMeasurement(panel);
              this.renderMatches(panel);
            }
          }
        });
      }
      closeBreedLists() {
        this.querySelectorAll('[data-breed-list]').forEach(list => { list.hidden = true; });
        this.querySelectorAll('[data-breed-search-status]').forEach(status => { status.textContent = ''; });
        this.querySelectorAll('[data-breed-input]').forEach(input => {
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');
        });
        this.breedActiveIndex = -1;
      }
      renderBreedOptions(panel) {
        const input = panel?.querySelector('[data-breed-input]');
        const list = panel?.querySelector('[data-breed-list]');
        if (!input || !list) return;
        this.closeBreedLists();
        const query = this.normalizeSearch(input.value);
        const matches = this.breeds.filter(breed => this.normalizeSearch(breed.name).includes(query));
        const options = [...matches, { handle: '__unknown__', name: this.breedLabels.unknown || '' }];
        list.replaceChildren();
        options.forEach((breed, index) => {
          const option = document.createElement('div');
          option.id = input.id + '-option-' + index;
          option.dataset.breedOption = breed.handle;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', String(breed.handle === this.breedHandle));
          option.textContent = breed.name;
          list.appendChild(option);
        });
        const status = panel.querySelector('[data-breed-search-status]');
        if (status) status.textContent = matches.length ? '' : this.breedLabels.noResults || '';
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        this.breedActiveIndex = -1;
      }
      onBreedKeydown(event, panel) {
        const input = panel.querySelector('[data-breed-input]');
        const list = panel.querySelector('[data-breed-list]');
        if (!input || !list) return;
        if (event.key === 'Escape') {
          if (!list.hidden) event.preventDefault();
          this.closeBreedLists();
          return;
        }
        if (event.key === 'Tab') {
          this.closeBreedLists();
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (list.hidden) this.renderBreedOptions(panel);
          const options = Array.from(list.querySelectorAll('[data-breed-option]'));
          if (!options.length) return;
          const current = Number.isInteger(this.breedActiveIndex) ? this.breedActiveIndex : -1;
          const next = current < 0 ? event.key === 'ArrowDown' ? 0 : options.length - 1 : Math.max(0, Math.min(options.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)));
          this.breedActiveIndex = next;
          options.forEach((option, index) => {
            option.toggleAttribute('data-active', index === next);
            option.setAttribute('aria-selected', String(index === next));
          });
          input.setAttribute('aria-activedescendant', options[next].id);
          options[next].scrollIntoView({ block: 'nearest' });
          return;
        }
        if (event.key === 'Enter' && !list.hidden && this.breedActiveIndex >= 0) {
          event.preventDefault();
          const option = list.querySelectorAll('[data-breed-option]')[this.breedActiveIndex];
          if (option) this.chooseBreed(option.dataset.breedOption);
        }
      }
      chooseBreed(handle) {
        const breed = this.breeds.find(record => record.handle === handle);
        if (!breed && handle !== '__unknown__') return;
        this.breedHandle = handle;
        this.breedQuery = breed?.name || this.breedLabels.unknown || '';
        this.breedSubmitted = false;
        this.querySelectorAll('[data-breed-input]').forEach(input => { input.value = this.breedQuery; });
        this.panels.forEach(panel => { this.resetBreedResult(panel); });
        this.closeBreedLists();
        this.syncPath();
      }
      updateBreedPhoto(panel, useBreed) {
        const portrait = panel.querySelector('[data-breed-portrait]');
        const image = portrait?.querySelector('[data-breed-image]');
        const measurePhoto = panel.querySelector('[data-measure-photo]');
        const measureCaption = panel.querySelector('[data-measure-caption]');
        const heading = panel.querySelector('[data-art-title]');
        const breed = this.breeds.find(record => record.handle === this.breedHandle);
        const show = Boolean(this.dataset.breedPhotos === 'true' && useBreed && breed?.image && portrait && image);
        if (portrait) portrait.hidden = !show;
        if (measurePhoto) measurePhoto.hidden = show;
        if (measureCaption) measureCaption.hidden = show;
        if (heading) heading.textContent = show ? (this.dataset.breedPhotoTitle || '[race]').replaceAll('[race]', breed.name) : heading.dataset.defaultTitle;
        if (!image) return;
        image.onerror = show ? () => {
          portrait.hidden = true;
          if (measurePhoto) measurePhoto.hidden = false;
          if (measureCaption) measureCaption.hidden = false;
          if (heading) heading.textContent = heading.dataset.defaultTitle;
        } : null;
        if (show) {
          image.alt = breed.imageAlt || breed.name;
          if (image.getAttribute('src') !== breed.image) image.src = breed.image;
        }
      }
      resetBreedResult(panel) {
        const result = panel.querySelector('[data-breed-result]');
        if (result) result.hidden = true;
        panel.querySelectorAll('[data-breed-size]').forEach(row => {
          row.removeAttribute('data-breed-match');
          const badge = row.querySelector('[data-breed-badge]');
          if (badge) badge.hidden = true;
        });
      }
      renderBreedResult(panel) {
        this.resetBreedResult(panel);
        const result = panel.querySelector('[data-breed-result]');
        if (!result || panel.dataset.mode !== 'measurement' || !['harnais', 'collier'].includes(panel.dataset.breedField)) return null;
        const breed = this.breeds.find(record => record.handle === this.breedHandle);
        const size = this.normalizeSize(breed?.[panel.dataset.breedField]);
        const rows = size ? Array.from(panel.querySelectorAll('[data-breed-size]')).filter(row => row.dataset.breedSize === size) : [];
        const matched = rows.length === 1 && rows[0].dataset.sizeName?.trim() && this.parseRange(rows[0].dataset.sizeRange) ? rows[0] : null;
        result.querySelector('[data-breed-result-label]').textContent = !this.breedHandle ? this.breedLabels.choose || '' : matched ? this.breedLabels.indicative || '' : this.breedLabels.unavailable || '';
        result.querySelector('[data-breed-result-size]').textContent = matched ? matched.dataset.sizeName : '';
        const note = result.querySelector('[data-breed-result-note]');
        if (note) note.hidden = !matched;
        result.hidden = false;
        if (matched) {
          matched.setAttribute('data-breed-match', '');
          const badge = matched.querySelector('[data-breed-badge]');
          if (badge) badge.hidden = false;
        }
        return matched;
      }
      setUnit(unit) {
        if (unit !== 'cm' && unit !== 'in') return;
        this.unit = unit;
        this.querySelectorAll('[data-unit]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
        });
        this.querySelectorAll('[data-unit-column]').forEach(column => { column.hidden = column.dataset.unitColumn !== unit; });
        this.querySelectorAll('[data-unit-label]').forEach(label => { label.textContent = this.labels[unit]; });
        this.panels.forEach(panel => {
          const input = panel.querySelector('[data-measure-form] input');
          const cm = this.measurements.get(panel.dataset.categoryPanel);
          if (input) {
            input.min = String(unit === 'cm' ? 0.1 : 0.1 / 2.54);
            if (Number.isFinite(cm)) input.value = String(Number((cm / (unit === 'in' ? 2.54 : 1)).toFixed(2)));
          }
          this.renderMeasurement(panel);
        });
      }
      renderMeasurement(panel) {
        const output = panel.querySelector('[data-result-value]');
        const cm = this.measurements.get(panel.dataset.categoryPanel);
        if (!output || !Number.isFinite(cm)) return;
        const locale = document.documentElement.lang || 'fr';
        const value = cm / (this.unit === 'in' ? 2.54 : 1);
        output.textContent = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value) + ' ' + this.labels[this.unit];
      }
      parseRange(value) {
        const match = String(value || '').match(/^\s*(\d+(?:[.,]\d+)?)\s*[-–—]\s*(\d+(?:[.,]\d+)?)\s*$/);
        if (!match) return null;
        const min = Number(match[1].replace(',', '.'));
        const max = Number(match[2].replace(',', '.'));
        return Number.isFinite(min) && Number.isFinite(max) && min >= 0 && max > 0 && min <= max ? { min, max } : null;
      }
      renderRangeUnits(panel) {
        if (panel.dataset.mode !== 'measurement') return;
        const format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { maximumFractionDigits: 2 });
        panel.querySelectorAll('[data-size-range]').forEach(row => {
          const range = this.parseRange(row.dataset.sizeRange);
          const cell = row.querySelector('[data-unit-column="in"]');
          if (!range || !cell) return;
          const prefix = this.dataset.approxLabel ? this.dataset.approxLabel + ' ' : '';
          cell.textContent = prefix + format.format(range.min / 2.54) + '–' + format.format(range.max / 2.54);
        });
      }
      resetResult(panel) {
        const result = panel.querySelector('.bk-guide-fit-avant__result');
        if (result) result.hidden = true;
        panel.querySelectorAll('[data-size-range]').forEach(row => {
          row.removeAttribute('data-size-match');
          const badge = row.querySelector('[data-match-badge]');
          if (badge) badge.hidden = true;
        });
      }
      renderMatches(panel) {
        const result = panel.querySelector('.bk-guide-fit-avant__result');
        const cm = this.measurements.get(panel.dataset.categoryPanel);
        if (!result || !Number.isFinite(cm) || panel.dataset.mode !== 'measurement') return;
        const rows = Array.from(panel.querySelectorAll('[data-size-range]'));
        const ranges = rows.map(row => this.parseRange(row.dataset.sizeRange));
        const valid = rows.length > 0 && ranges.every(Boolean) && rows.every(row => row.dataset.sizeName?.trim());
        const matches = valid ? rows.filter((row, index) => {
          const { min, max } = ranges[index];
          const epsilon = Number.EPSILON * Math.max(1, Math.abs(cm), max) * 8;
          return cm >= min - epsilon && cm <= max + epsilon;
        }) : [];
        rows.forEach(row => {
          const matched = matches.includes(row);
          row.toggleAttribute('data-size-match', matched);
          const badge = row.querySelector('[data-match-badge]');
          if (badge) badge.hidden = !matched;
        });
        const label = !valid ? result.dataset.invalidRangesMessage : matches.length > 1 ? result.dataset.multipleMatchLabel : matches.length === 1 ? result.dataset.uniqueMatchLabel : result.dataset.noMatchMessage;
        result.querySelector('[data-result-label]').textContent = label;
        result.querySelector('[data-result-sizes]').textContent = matches.map(row => row.dataset.sizeName).join(', ');
        result.querySelector('[data-overlap-note]').hidden = matches.length < 2;
      }
      openTable(panel, moveFocus) {
        const table = panel?.querySelector('[data-size-table]');
        if (!table) return;
        table.open = true;
        if (moveFocus) {
          table.querySelector('summary')?.focus({ preventScroll: true });
          table.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-guide-fit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bk-guide-fit')) {
    customElements.define('bk-guide-fit', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.panels = Array.from(this.querySelectorAll('[data-category-panel]'));
        this.measurements = this.measurements || new Map();
        this.confirmedMeasurements = this.confirmedMeasurements || new Map();
        this.path = this.path || 'measure';
        this.setupBreeds();
        this.unit = this.unit || (this.dataset.defaultUnit === 'in' ? 'in' : 'cm');
        this.labels = {
          cm: this.querySelector('[data-unit="cm"]')?.textContent || '',
          in: this.querySelector('[data-unit="in"]')?.textContent || ''
        };
        this.panels.forEach(panel => {
          const table = panel.querySelector('[data-size-table]');
          if (table) table.open = this.dataset.tablesOpen === 'true';
          this.renderRangeUnits(panel);
        });
        this.addEventListener('click', event => {
          const pathButton = event.target.closest('[data-path-button]');
          if (pathButton && this.contains(pathButton)) this.selectPath(pathButton.dataset.pathButton);
          const nowMeasure = event.target.closest('[data-now-measure]');
          if (nowMeasure && this.contains(nowMeasure)) {
            const panel = nowMeasure.closest('[data-category-panel]');
            const guide = panel?.querySelector('[data-measure-guide]');
            if (guide) guide.open = false;
            this.selectPath('measure', true);
            panel?.querySelector('[data-measure-form]')?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }
          const breedOption = event.target.closest('[data-breed-option]');
          if (breedOption && this.contains(breedOption)) this.chooseBreed(breedOption.dataset.breedOption);
          const breedInput = event.target.closest('[data-breed-input]');
          if (breedInput && this.contains(breedInput)) this.renderBreedOptions(breedInput.closest('[data-category-panel]'));
          const categoryButton = event.target.closest('[data-category-button]');
          if (categoryButton && this.contains(categoryButton)) this.selectCategory(categoryButton.dataset.categoryButton);
          const unitButton = event.target.closest('[data-unit]');
          if (unitButton && this.contains(unitButton)) this.setUnit(unitButton.dataset.unit);
          const tableLink = event.target.closest('[data-table-link]');
          if (tableLink && this.contains(tableLink)) {
            event.preventDefault();
            this.openTable(tableLink.closest('[data-category-panel]'), true);
          }
        }, { signal });
        this.addEventListener('input', event => {
          const breedInput = event.target.closest('[data-breed-input]');
          if (breedInput && this.contains(breedInput)) {
            this.breedHandle = null;
            this.breedSubmitted = false;
            this.breedQuery = breedInput.value;
            this.panels.forEach(panel => {
              this.resetBreedResult(panel);
              const other = panel.querySelector('[data-breed-input]');
              if (other && other !== breedInput) other.value = this.breedQuery;
            });
            this.syncPath();
            this.renderBreedOptions(breedInput.closest('[data-category-panel]'));
            return;
          }
          const input = event.target.closest('[data-measure-form] input');
          if (!input || !this.contains(input)) return;
          const panel = input.closest('[data-category-panel]');
          const number = input.valueAsNumber;
          this.measurements.set(panel.dataset.categoryPanel, Number.isFinite(number) ? number * (this.unit === 'in' ? 2.54 : 1) : null);
          this.confirmedMeasurements.delete(panel.dataset.categoryPanel);
          this.resetResult(panel);
        }, { signal });
        this.addEventListener('submit', event => {
          const breedForm = event.target.closest('[data-breed-form]');
          if (breedForm && this.contains(breedForm)) {
            event.preventDefault();
            this.breedSubmitted = true;
            this.closeBreedLists();
            this.syncPath();
            this.openTable(breedForm.closest('[data-category-panel]'), false);
            return;
          }
          const form = event.target.closest('[data-measure-form]');
          if (!form || !this.contains(form)) return;
          event.preventDefault();
          const input = form.querySelector('input');
          if (!input.reportValidity()) return;
          const panel = form.closest('[data-category-panel]');
          const number = input.valueAsNumber;
          if (!Number.isFinite(number) || number <= 0) return;
          if (!Number.isFinite(this.measurements.get(panel.dataset.categoryPanel))) {
            this.measurements.set(panel.dataset.categoryPanel, number * (this.unit === 'in' ? 2.54 : 1));
          }
          this.confirmedMeasurements.set(panel.dataset.categoryPanel, this.measurements.get(panel.dataset.categoryPanel));
          this.resetBreedResult(panel);
          panel.querySelector('.bk-guide-fit__result').hidden = false;
          this.renderMeasurement(panel);
          this.renderMatches(panel);
          this.openTable(panel, false);
        }, { signal });
        this.addEventListener('focusin', event => {
          const input = event.target.closest('[data-breed-input]');
          if (input && this.contains(input)) this.renderBreedOptions(input.closest('[data-category-panel]'));
        }, { signal });
        this.addEventListener('focusout', event => {
          const picker = event.target.closest('[data-breed-picker]');
          if (picker && !picker.contains(event.relatedTarget)) this.closeBreedLists();
        }, { signal });
        this.addEventListener('pointerdown', event => {
          const option = event.target.closest('[data-breed-option]');
          if (option && this.contains(option)) event.preventDefault();
        }, { signal });
        this.addEventListener('keydown', event => {
          const input = event.target.closest('[data-breed-input]');
          if (input && this.contains(input)) this.onBreedKeydown(event, input.closest('[data-category-panel]'));
        }, { signal });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closeBreedLists();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const selected = event.target.closest('[data-block-id]');
          const panel = selected?.closest('[data-category-panel]');
          if (!panel) return;
          this.selectCategory(panel.dataset.categoryPanel);
          if (selected !== panel) this.openTable(panel, false);
        }, { signal });
        this.setAttribute('data-enhanced', '');
        const active = this.panels.find(panel => panel.dataset.categoryPanel === this.activeCategory) || this.panels[0];
        this.selectCategory(active?.dataset.categoryPanel);
        this.setUnit(this.unit);
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.closeBreedLists();
        this.removeAttribute('data-enhanced');
        this.panels?.forEach(panel => {
          panel.hidden = false;
          const table = panel.querySelector('[data-size-table]');
          if (table) table.open = true;
        });
        this.querySelectorAll('[data-unit-column]').forEach(column => { column.hidden = false; });
      }
      selectCategory(id) {
        if (!id) return;
        this.activeCategory = id;
        this.panels.forEach(panel => { panel.hidden = panel.dataset.categoryPanel !== id; });
        this.querySelectorAll('[data-category-button]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.categoryButton === id));
        });
        this.closeBreedLists();
        this.syncPath();
      }
      setupBreeds() {
        let records = [];
        this.breedLabels = {};
        try {
          records = JSON.parse(this.querySelector('[data-breed-data]')?.textContent || '[]');
          this.breedLabels = JSON.parse(this.querySelector('[data-breed-labels]')?.textContent || '{}');
        } catch {
          records = [];
        }
        if (!Array.isArray(records)) records = [];
        if (!this.breedLabels || typeof this.breedLabels !== 'object' || Array.isArray(this.breedLabels)) this.breedLabels = {};
        this.breeds = records.filter(breed => breed && typeof breed.handle === 'string' && breed.handle && breed.handle !== '__unknown__' && typeof breed.name === 'string' && breed.name.trim() && records.filter(record => record?.handle === breed.handle).length === 1);
        this.breeds.sort((a, b) => a.name.localeCompare(b.name, document.documentElement.lang || 'fr'));
        if (this.breedHandle && this.breedHandle !== '__unknown__' && !this.breeds.some(breed => breed.handle === this.breedHandle)) {
          this.breedHandle = null;
          this.breedSubmitted = false;
        }
        const selected = this.breeds.find(breed => breed.handle === this.breedHandle);
        if (selected || this.breedHandle === '__unknown__') this.breedQuery = selected?.name || this.breedLabels.unknown || '';
        this.querySelectorAll('[data-breed-input]').forEach(input => { input.value = this.breedQuery || ''; });
      }
      normalizeSearch(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      }
      normalizeSize(value) {
        const normalized = this.normalizeSearch(value).replace(/[-‐‑‒–—−]/g, ' ').replace(/\s+/g, ' ').trim();
        const aliases = {
          'tt petit': 'xxs', 'xx small': 'xxs', 'xxs': 'xxs',
          't petit': 'xs', 'x small': 'xs', 'xs': 'xs',
          'petit': 's', 'small': 's', 's': 's',
          'moyen': 'm', 'medium': 'm', 'm': 'm',
          'large': 'l', 'l': 'l'
        };
        return Object.hasOwn(aliases, normalized) ? aliases[normalized] : null;
      }
      selectPath(path, moveFocus = false) {
        if (path !== 'measure' && path !== 'breed') return;
        this.path = path;
        this.closeBreedLists();
        this.syncPath();
        if (moveFocus) {
          this.panels.find(panel => panel.dataset.categoryPanel === this.activeCategory)?.querySelector('[data-measure-form] input')?.focus({ preventScroll: true });
        }
      }
      syncPath() {
        this.panels.forEach(panel => {
          const breedPath = panel.querySelector('[data-breed-path]');
          const measurePath = panel.querySelector('[data-measure-path]');
          const useBreed = Boolean(breedPath) && (panel.dataset.mode === 'dimensions' || (this.path === 'breed' && panel.dataset.mode === 'measurement'));
          this.updateBreedPhoto(panel, useBreed);
          if (breedPath) breedPath.hidden = !useBreed;
          if (measurePath) measurePath.hidden = useBreed;
          panel.querySelectorAll('[data-path-button]').forEach(button => {
            button.setAttribute('aria-pressed', String(button.dataset.pathButton === (useBreed ? 'breed' : 'measure')));
          });
          this.resetResult(panel);
          this.resetBreedResult(panel);
          if (useBreed && this.breedSubmitted) this.renderBreedResult(panel);
          if (!useBreed && panel.dataset.mode === 'measurement') {
            const cm = this.measurements.get(panel.dataset.categoryPanel);
            if (Number.isFinite(cm) && cm > 0 && this.confirmedMeasurements?.get(panel.dataset.categoryPanel) === cm) {
              const result = panel.querySelector('.bk-guide-fit__result');
              if (result) result.hidden = false;
              this.renderMeasurement(panel);
              this.renderMatches(panel);
            }
          }
        });
      }
      closeBreedLists() {
        this.querySelectorAll('[data-breed-list]').forEach(list => { list.hidden = true; });
        this.querySelectorAll('[data-breed-search-status]').forEach(status => { status.textContent = ''; });
        this.querySelectorAll('[data-breed-input]').forEach(input => {
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');
        });
        this.breedActiveIndex = -1;
      }
      renderBreedOptions(panel) {
        const input = panel?.querySelector('[data-breed-input]');
        const list = panel?.querySelector('[data-breed-list]');
        if (!input || !list) return;
        this.closeBreedLists();
        const query = this.breedHandle ? '' : this.normalizeSearch(input.value);
        if (this.breedHandle) input.select();
        const matches = this.breeds.filter(breed => this.normalizeSearch(breed.name).includes(query));
        const options = [...matches, { handle: '__unknown__', name: this.breedLabels.unknown || '' }];
        list.replaceChildren();
        options.forEach((breed, index) => {
          const option = document.createElement('div');
          option.id = input.id + '-option-' + index;
          option.dataset.breedOption = breed.handle;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', String(breed.handle === this.breedHandle));
          option.textContent = breed.name;
          list.appendChild(option);
        });
        const status = panel.querySelector('[data-breed-search-status]');
        if (status) status.textContent = matches.length ? '' : this.breedLabels.noResults || '';
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        this.breedActiveIndex = -1;
      }
      onBreedKeydown(event, panel) {
        const input = panel.querySelector('[data-breed-input]');
        const list = panel.querySelector('[data-breed-list]');
        if (!input || !list) return;
        if (event.key === 'Escape') {
          if (!list.hidden) event.preventDefault();
          this.closeBreedLists();
          return;
        }
        if (event.key === 'Tab') {
          this.closeBreedLists();
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (list.hidden) this.renderBreedOptions(panel);
          const options = Array.from(list.querySelectorAll('[data-breed-option]'));
          if (!options.length) return;
          const current = Number.isInteger(this.breedActiveIndex) ? this.breedActiveIndex : -1;
          const next = current < 0 ? event.key === 'ArrowDown' ? 0 : options.length - 1 : Math.max(0, Math.min(options.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)));
          this.breedActiveIndex = next;
          options.forEach((option, index) => {
            option.toggleAttribute('data-active', index === next);
            option.setAttribute('aria-selected', String(index === next));
          });
          input.setAttribute('aria-activedescendant', options[next].id);
          options[next].scrollIntoView({ block: 'nearest' });
          return;
        }
        if (event.key === 'Enter' && !list.hidden && this.breedActiveIndex >= 0) {
          event.preventDefault();
          const option = list.querySelectorAll('[data-breed-option]')[this.breedActiveIndex];
          if (option) this.chooseBreed(option.dataset.breedOption);
        }
      }
      chooseBreed(handle) {
        const breed = this.breeds.find(record => record.handle === handle);
        if (!breed && handle !== '__unknown__') return;
        this.breedHandle = handle;
        this.breedQuery = breed?.name || this.breedLabels.unknown || '';
        this.breedSubmitted = true;
        this.querySelectorAll('[data-breed-input]').forEach(input => { input.value = this.breedQuery; });
        this.panels.forEach(panel => { this.resetBreedResult(panel); });
        this.closeBreedLists();
        this.syncPath();
        const panel = this.panels.find(item => item.dataset.categoryPanel === this.activeCategory);
        if (panel?.dataset.mode === 'dimensions' && panel.dataset.breedField === 'laisse' && panel.querySelector('[data-breed-match]')) this.openTable(panel, false);
      }
      updateBreedPhoto(panel, useBreed) {
        const portrait = panel.querySelector('[data-breed-portrait]');
        const image = portrait?.querySelector('[data-breed-image]');
        const measurePhoto = panel.querySelector('[data-measure-photo]');
        const measureCaption = panel.querySelector('[data-measure-caption]');
        const heading = panel.querySelector('[data-art-title]');
        const breed = this.breeds.find(record => record.handle === this.breedHandle);
        const show = Boolean(this.dataset.breedPhotos === 'true' && useBreed && breed?.image && portrait && image);
        panel.toggleAttribute('data-has-portrait', show);
        if (portrait) portrait.hidden = !show;
        if (measurePhoto) measurePhoto.hidden = show;
        if (measureCaption) measureCaption.hidden = show;
        if (heading) heading.textContent = show ? (this.dataset.breedPhotoTitle || '[race]').replaceAll('[race]', breed.name) : heading.dataset.defaultTitle;
        if (!image) return;
        image.onerror = show ? () => {
          portrait.hidden = true;
          panel.removeAttribute('data-has-portrait');
          if (measurePhoto) measurePhoto.hidden = false;
          if (measureCaption) measureCaption.hidden = false;
          if (heading) heading.textContent = heading.dataset.defaultTitle;
        } : null;
        if (show) {
          image.alt = breed.imageAlt || breed.name;
          if (image.getAttribute('src') !== breed.image) image.src = breed.image;
        }
      }
      resetBreedResult(panel) {
        const result = panel.querySelector('[data-breed-result]');
        if (result) result.hidden = true;
        panel.querySelectorAll('[data-breed-size]').forEach(row => {
          row.removeAttribute('data-breed-match');
          const badge = row.querySelector('[data-breed-badge]');
          if (badge) badge.hidden = true;
        });
      }
      renderBreedResult(panel) {
        this.resetBreedResult(panel);
        const result = panel.querySelector('[data-breed-result]');
        const leash = panel.dataset.mode === 'dimensions' && panel.dataset.breedField === 'laisse';
        if (!result || (!leash && (panel.dataset.mode !== 'measurement' || !['harnais', 'collier'].includes(panel.dataset.breedField)))) return null;
        const breed = this.breeds.find(record => record.handle === this.breedHandle);
        const size = this.normalizeSize(breed?.[panel.dataset.breedField]);
        const rows = size ? Array.from(panel.querySelectorAll('[data-breed-size]')).filter(row => row.dataset.breedSize === size) : [];
        const matched = rows.length === 1 && rows[0].dataset.sizeName?.trim() && (leash || this.parseRange(rows[0].dataset.sizeRange)) ? rows[0] : null;
        result.querySelector('[data-breed-result-label]').textContent = !this.breedHandle ? this.breedLabels.choose || '' : matched ? this.breedLabels.indicative || '' : this.breedLabels.unavailable || '';
        result.querySelector('[data-breed-result-size]').textContent = matched ? matched.dataset.sizeName : '';
        const note = result.querySelector('[data-breed-result-note]');
        if (note) note.hidden = !matched;
        result.hidden = false;
        if (matched) {
          matched.setAttribute('data-breed-match', '');
          const badge = matched.querySelector('[data-breed-badge]');
          if (badge) badge.hidden = false;
        }
        return matched;
      }
      setUnit(unit) {
        if (unit !== 'cm' && unit !== 'in') return;
        this.unit = unit;
        this.querySelectorAll('[data-unit]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
        });
        this.querySelectorAll('[data-unit-column]').forEach(column => { column.hidden = false; });
        this.querySelectorAll('[data-unit-label]').forEach(label => { label.textContent = this.labels[unit]; });
        this.panels.forEach(panel => {
          const input = panel.querySelector('[data-measure-form] input');
          const cm = this.measurements.get(panel.dataset.categoryPanel);
          if (input) {
            input.min = String(unit === 'cm' ? 0.1 : 0.1 / 2.54);
            if (Number.isFinite(cm)) input.value = String(Number((cm / (unit === 'in' ? 2.54 : 1)).toFixed(2)));
          }
          this.renderMeasurement(panel);
        });
      }
      renderMeasurement(panel) {
        const output = panel.querySelector('[data-result-value]');
        const cm = this.measurements.get(panel.dataset.categoryPanel);
        if (!output || !Number.isFinite(cm)) return;
        const locale = document.documentElement.lang || 'fr';
        const value = cm / (this.unit === 'in' ? 2.54 : 1);
        output.textContent = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value) + ' ' + this.labels[this.unit];
      }
      parseRange(value) {
        const match = String(value || '').match(/^\s*(\d+(?:[.,]\d+)?)\s*[-–—]\s*(\d+(?:[.,]\d+)?)\s*$/);
        if (!match) return null;
        const min = Number(match[1].replace(',', '.'));
        const max = Number(match[2].replace(',', '.'));
        return Number.isFinite(min) && Number.isFinite(max) && min >= 0 && max > 0 && min <= max ? { min, max } : null;
      }
      renderRangeUnits(panel) {
        if (panel.dataset.mode !== 'measurement') return;
        const format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { maximumFractionDigits: 2 });
        panel.querySelectorAll('[data-size-range]').forEach(row => {
          const range = this.parseRange(row.dataset.sizeRange);
          const cell = row.querySelector('[data-unit-column="in"]');
          if (!range || !cell) return;
          const prefix = this.dataset.approxLabel ? this.dataset.approxLabel + ' ' : '';
          cell.textContent = prefix + format.format(range.min / 2.54) + '–' + format.format(range.max / 2.54);
        });
      }
      resetResult(panel) {
        const result = panel.querySelector('.bk-guide-fit__result');
        if (result) result.hidden = true;
        panel.querySelectorAll('[data-size-range]').forEach(row => {
          row.removeAttribute('data-size-match');
          const badge = row.querySelector('[data-match-badge]');
          if (badge) badge.hidden = true;
        });
      }
      renderMatches(panel) {
        const result = panel.querySelector('.bk-guide-fit__result');
        const cm = this.measurements.get(panel.dataset.categoryPanel);
        if (!result || !Number.isFinite(cm) || panel.dataset.mode !== 'measurement') return;
        const rows = Array.from(panel.querySelectorAll('[data-size-range]'));
        const ranges = rows.map(row => this.parseRange(row.dataset.sizeRange));
        const valid = rows.length > 0 && ranges.every(Boolean) && rows.every(row => row.dataset.sizeName?.trim());
        const matches = valid ? rows.filter((row, index) => {
          const { min, max } = ranges[index];
          const epsilon = Number.EPSILON * Math.max(1, Math.abs(cm), max) * 8;
          return cm >= min - epsilon && cm <= max + epsilon;
        }) : [];
        rows.forEach(row => {
          const matched = matches.includes(row);
          row.toggleAttribute('data-size-match', matched);
          const badge = row.querySelector('[data-match-badge]');
          if (badge) badge.hidden = !matched;
        });
        const label = !valid ? result.dataset.invalidRangesMessage : matches.length > 1 ? result.dataset.multipleMatchLabel : matches.length === 1 ? result.dataset.uniqueMatchLabel : result.dataset.noMatchMessage;
        result.querySelector('[data-result-label]').textContent = label;
        result.querySelector('[data-result-sizes]').textContent = matches.map(row => row.dataset.sizeName).join(', ');
        result.querySelector('[data-overlap-note]').hidden = matches.length < 2;
      }
      openTable(panel, moveFocus) {
        const table = panel?.querySelector('[data-size-table]');
        if (!table) return;
        table.open = true;
        if (moveFocus) {
          table.querySelector('summary')?.focus({ preventScroll: true });
          table.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-guide-help-avant"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bk-guide-help-avant')) {
  customElements.define('bk-guide-help-avant', class extends HTMLElement {
    connectedCallback() {
      this.selectionController?.abort();
      this.selectionController = new AbortController();
      this.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element)) return;
        const question = event.target.closest('.bk-guide-help-avant__faq');
        if (question && this.contains(question)) question.open = true;
      }, { signal: this.selectionController.signal });
    }

    disconnectedCallback() {
      this.selectionController?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-guide-help"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bk-guide-help')) {
  customElements.define('bk-guide-help', class extends HTMLElement {
    connectedCallback() {
      this.selectionController?.abort();
      this.selectionController = new AbortController();
      this.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element)) return;
        const question = event.target.closest('.bk-guide-help__faq');
        if (question && this.contains(question)) question.open = true;
      }, { signal: this.selectionController.signal });
    }

    disconnectedCallback() {
      this.selectionController?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
